import * as ResizablePrimitive from 'react-resizable-panels';

import { GripVertical } from 'lucide-react';

import { cn } from '@/lib/utils';

const ResizablePanelGroup = ({
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.Group>) => (
    <ResizablePrimitive.Group
        className={cn('h-full w-full', className)}
        {...props}
    />
);

// v4 panels scroll their own overflow (`overflow: auto`); v3 clipped it. Keep
// clipping so the editor's inner scroll regions stay the only scrollbars.
const ResizablePanel = ({
    style,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.Panel>) => (
    <ResizablePrimitive.Panel
        style={{ overflow: 'hidden', ...style }}
        {...props}
    />
);

// The separator's aria-orientation is perpendicular to the group's: a
// horizontal group renders a vertical separator, and vice versa.
const ResizableHandle = ({
    withHandle,
    className,
    ...props
}: React.ComponentProps<typeof ResizablePrimitive.Separator> & {
    withHandle?: boolean;
}) => (
    <ResizablePrimitive.Separator
        className={cn(
            'relative flex w-px cursor-col-resize items-center justify-center bg-border',
            'after:absolute after:inset-y-0 after:left-1/2 after:w-3 after:-translate-x-1/2',
            'hover:bg-primary/40',
            'focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1',
            'aria-[orientation=horizontal]:h-px aria-[orientation=horizontal]:w-full aria-[orientation=horizontal]:cursor-row-resize',
            'aria-[orientation=horizontal]:after:left-0 aria-[orientation=horizontal]:after:h-3 aria-[orientation=horizontal]:after:w-full aria-[orientation=horizontal]:after:-translate-y-1/2 aria-[orientation=horizontal]:after:translate-x-0',
            '[&[aria-orientation=horizontal]>div]:rotate-90',
            className,
        )}
        {...props}
    >
        {withHandle && (
            <div className="z-10 flex h-4 w-3 items-center justify-center rounded-sm border bg-border">
                <GripVertical className="h-2.5 w-2.5" />
            </div>
        )}
    </ResizablePrimitive.Separator>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
